import {
  HabitSchedule,
  ScheduleEntryState,
  Timestamp,
  WeekDays,
} from '@griply/types';

import { isBetween } from './lib/date-fns';
import { getScheduleTimeframeByDate } from './schedules/get-schedule-timeframe-by-date';

export type Options = {
  referenceDate: Timestamp;
  weekStartsOn: WeekDays;
};

export const getFrequencyTimeframeCompletions = (
  schedule: HabitSchedule,
  { referenceDate, weekStartsOn }: Options,
) => {
  const { startDate, endDate } = getScheduleTimeframeByDate(
    schedule,
    referenceDate,
    weekStartsOn,
  );

  const completions = schedule.entries.filter(
    ({ date, state }) =>
      state === ScheduleEntryState.Complete &&
      isBetween(date, startDate, endDate),
  );

  return {
    completionsCount: completions.reduce(
      (acc, { value }) => acc + (value ?? 0),
      0,
    ),
    target: schedule.frequency?.count ?? 1,
  };
};
